//import other scripts to work with webpack
import './practitioner-search.js';
import './ie.js';
import './widgets/podcasts.js'




/*
 * Global JS, that does not belong to an Elementor widget
 * If this gets large, sections can be pulled out into their own js file in the src/js folder, and will be picked up by gulp
 */


( function( $ ) {
    window.$ = $;

    //fix elementor youtube autoplay bug in chrome
    $('.elementor-video-iframe').attr('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');




})(( jQuery ));